<app-account-form
  [sysText]="sysText$ | async"
  [options]="options"
  [page]="templateName"
  [isSubmitting]="isSubmitting$ | async"
  (formSubmit)="onFormSubmit($event)">
</app-account-form>
